import request from './index'

export function getBannerList() {
  return request({
    url: '/banner/list',
    method: 'get'
  })
}

export function createBanner(data) {
  return request({
    url: '/banner',
    method: 'post',
    data
  })
}

export function updateBanner(id, data) {
  return request({
    url: '/banner/' + id,
    method: 'put',
    data
  })
}

export function deleteBanner(id) {
  return request({
    url: '/banner/' + id,
    method: 'delete'
  })
}

export function updateBannerStatus(id, status) {
  return request({
    url: '/banner/' + id + '/status',
    method: 'put',
    params: { status }
  })
}